/* eslint-disable consistent-return */

import Keypress from 'keypress.js';

export default {

  data() {
    return {
      opened: false,
      tabIndex: 0,
      tabCount: 0,
    };
  },

  methods: {
    registerAdminKeyboardListeners() {
      this.listener = new Keypress.Listener();

      this.listener.simple_combo('left', (event) => {
        this.tabCount = $(`#modal-${this.modalId} .v--modal .nav-tabs li`).length;

        if (!this.opened) {
          return true;
        }

        if (this.tabIndex === 0) {
          this.tabIndex = this.tabCount - 1;
        } else {
          this.tabIndex -= 1;
        }
      });

      this.listener.simple_combo('right', (event) => {
        this.tabCount = $(`#modal-${this.modalId} .v--modal .nav-tabs li`).length;

        if (!this.opened) {
          return true;
        }

        if (this.tabIndex === this.tabCount - 1) {
          this.tabIndex = 0;
        } else {
          this.tabIndex += 1;
        }
      });
    },

    modalOpened() {
      // this.tabCount = $(`#modal-${this.modalId} .v--modal .nav-tabs li`).length;
      // console.log('modalHelpers.onOpened');
      // console.log('modalHelpers.tabCount', this.tabCount);
      this.opened = true;
      this.registerAdminKeyboardListeners();
    },

    modalClosed() {
      // console.log('modalHelpers.onClosed');
      this.opened = false;
      this.listener.reset();
    },

  },

};
